<template>
  <main>
    <div class="container">
      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div class="d-flex justify-content-center py-4">
                <router-link to="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/logo.png" alt="">
                  <span class="d-none d-lg-block">FinPlan</span>
                </router-link>
              </div>

              <div class="card mb-3">

                <div class="card-body">

                  <div class="pt-4 pb-2">
                    <h5 class="card-title text-center pb-0 fs-4">Подтверждение аккаунта</h5>
                    <p class="text-center small">Подтвердите почту</p>
                  </div>
                  <ConfirmForm/>
                </div>
              </div>

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup>
import ConfirmForm from "@/features/personal/components/ConfirmForm.vue";
</script>
